// extracted by mini-css-extract-plugin
export default {"container":"splitProduct_container__BjmEW","label":"splitProduct_label__5LW2H","items":"splitProduct_items__diqu2","item":"splitProduct_item__NJU5-"};